import request from '@/utils/request'
import qs from 'qs'
export function getEnterpriseIndexData() {
  return request({
    url: 'api/yumiIndexData',
    method: 'get'
  })
}
export function getEnterpriseTableData(params){
	
	return request({
	  url: 'api/yumiOrderSelf'+'?' + qs.stringify(params, { indices: false }),
	  method: 'get'
	})
	
	
}


export function enterpriseAdd(data) {
  return request({
    url: 'api/yumiOrderSelf',
    method: 'post',
    data
  })
}

export function editSelf(data) {
  return request({
    url: 'api/yumiEnterpriseUserSelf',
    method: 'put',
    data
  })
}